import api, { apiCredentials } from 'managers/apiManager';
import { GIVE_ACCESS_TO_ROLE } from 'config';
import { apiUsersUrls, issuerUrls } from 'config/endPoints';
import { extractAccount } from 'managers/usersDataManager';
import notificationManager from 'managers/notificationManager';

export const getChannelsForIssuer = (state, issuerId, handleIsBusy, handleData, notificationReference) => {
    // handleIsBusy(true);
    api
        .get(`${issuerUrls.API_ISSUERS_BASE}/${issuerId}${issuerUrls.API_ISSUERS_CHANNELS}`)
        .then((response) => {
            if (response.data.isSuccess) {
                handleData(response.data.data);
            }
        })
        .finally(() => {
            // handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            // handleIsBusy(false);
        });
};

export const getIssuersForUser = (state, userId, handleIsBusy, handleData, notificationReference) => {
    // handleIsBusy(true);
    api
        .get(`${apiUsersUrls.API_ISSUERS_FOR_USER}/${userId}`)
        .then((response) => {
            if (response.data.isSuccess) {
                handleData(response.data.data);
            }
        })
        .finally(() => {
            // handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            // handleIsBusy(false);
        });
};

export const handleAuthenticate = (state, data, handleIsBusy, handleIssuers, notificationReference) => {
    handleIsBusy(true);
    apiCredentials
        .post(apiUsersUrls.API_AUTHENTICATE_URL, data)
        .then((response) => {
            if (response.data.isSuccess) {
                const user = extractAccount(response.data);
                if (user.user.roles.some(role => role === GIVE_ACCESS_TO_ROLE)
                    && response.data.data.issuers
                    && response.data.data.issuers.length > 0) {
                    handleIssuers(user, response.data.data.issuers);
                } else {
                    notificationManager.error(state, null, notificationReference, "VW_ADMIN_USERS_NOAUTHORIZATION");
                }
            }
        })
        .finally(() => {
            handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            handleIsBusy(false);
        });
};

export const handleChangePassword = (state, data, handleIsBusy, handleAuthUser, notificationReference) => {
    handleIsBusy(true);
    api
        .post(apiUsersUrls.API_PASSWORD_CHANGE_URL, data)
        .then((response) => {
            if (response.data.isSuccess) {
                const user = extractAccount(response.data);
                handleAuthUser(user);
                notificationManager.success(state, "VW_ADMIN_USERS_CHANGE_PASSWORD_PASSWORD_SUCCESSFULLY_UPDATED", notificationReference);
            }
        })
        .finally(() => {
            handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            handleIsBusy(false);
        });
};

export const handleConfirmEmail = (state, token, handleSuccess, notificationReference) => {
    api
        .post(`/users/${token}/confirm-email`)
        .then((response) => {
            if (response.data.isSuccess) {
                handleSuccess(true);
                notificationManager.success(state, "Успешно верифициран емаил.", notificationReference);
            }
        })
        .finally(() => {
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
        });
};

export const handleForgotPassword = (state, data, handleIsBusy, handleSuccess, notificationReference) => {
    handleIsBusy(true);
    api
        .post(apiUsersUrls.API_PASSWORD_FORGOT_URL, data)
        .then((response) => {
            if (response.data.isSuccess) {
                handleSuccess(true);
            }
        })
        .finally(() => {
            handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            handleIsBusy(false);
        });
};

export const handleResetPassword = (state, token, data, handleIsBusy, handleSuccess, notificationReference) => {
    handleIsBusy(true);
    api
        .post(`/users/${token}/password-reset`, data)
        .then((response) => {
            if (response.data.isSuccess) {
                handleSuccess(true);
            }
        })
        .finally(() => {
            handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(state, error, notificationReference);
            handleIsBusy(false);
        });
};